<template>
  <div class="query_result">
    <van-tabs v-model="active" @change="handleChange">
      <van-tab title="政策资讯">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="title">
              符合您的政策资讯共<span>{{ total }}</span
              >条
            </div>
            <div
              :key="item.id"
              v-for="item in list"
              @click="togglePage('policeDetail', item)"
            >
              <police-list :item="item" :type="1"></police-list>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab title="服务项目">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="title">
              符合您的服务项目共<span>{{ total }}</span
              >条
            </div>
            <div
              v-for="item in list"
              :key="item.id"
              @click="togglePage('serviceDetail', item)"
            >
              <police-list :item="item" :type="2"></police-list>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab title="养老机构">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="title">
              符合您的养老机构共<span>{{ total }}</span
              >条
            </div>
            <div
              v-for="item in list"
              :key="item.orgId"
              @click="toggleOrg('agencyDetail', item.orgId)"
            >
              <agency-item :item="item" hasRightTag></agency-item>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab title="社区设施">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="title">
              符合您的社区设施共<span>{{ total }}</span
              >条
            </div>
            <div
              v-for="item in list"
              :key="item.id"
              @click="toggleOrg('agencyDetail', item.orgId)"
            >
              <agency-item :item="item" hasRightTag></agency-item>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getFuzzyCareList } from "@/api/home.js";
import { areaCode } from "@/common/constants.js";
import { debounce } from "@/utils/index";
export default {
  name: "QueryResult",
  data() {
    return {
      mainPageNum: 0,

      active: "",
      count: 0,
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      total: "",
      form: {
        areaCode,
        idCard: "",
        selectType: "1",
        pageSize: 10,
        pageNum: 0
      },
      getData: null
    };
  },
  methods: {
    getDataForApi(type) {
      if (type === "refresh" || type === "hand") {
        this.mainPageNum = 1;
        this.form.pageNum = 1;
      } else if (type === "load") {
        this.mainPageNum += 1;
        this.form.pageNum += 1;
      }
      if (this.$route.query.type === 0) {
        getFuzzyCareList(this.form)
          .then(res => {
            if (type === "load") {
              this.loading = false;
            } else if (type === "refresh") {
              this.refreshing = false;
            }

            if (res.code === 0) {
              let data = res.data;
              let tempList = [];
              switch (this.active) {
                case 0:
                  tempList = data.policyInformation.list;
                  this.total = data.policyInformation.total;
                  break;
                case 1:
                  tempList = data.serviceItems.list;
                  this.total = data.serviceItems.total;
                  break;
                case 2:
                  tempList = data.pensionAgency.list;
                  this.total = data.pensionAgency.total;
                  break;
                case 3:
                  tempList = data.communityFacility.list;
                  this.total = data.communityFacility.total;
              }

              if (tempList && tempList.length) {
                if (type === "load") {
                  this.list = this.list.concat(tempList);
                } else {
                  this.list = tempList;
                }
              } else {
                this.finished = true;
              }
            }
          })
          .catch(() => {
            if (type === "load") {
              this.loading = false;
            } else if (type === "refresh") {
              this.refreshing = false;
            }
          });
      } else {
        getFuzzyCareList({
          ...JSON.parse(this.$route.query.data),
          areaCode,
          selectType: this.form.selectType,
          pageSize: 10,
          pageNum: this.mainPageNum
        })
          .then(res => {
            if (type === "load") {
              this.loading = false;
            } else if (type === "refresh") {
              this.refreshing = false;
            }
            if (res.code === 0) {
              let data = res.data;
              let tempList = [];
              switch (this.active) {
                case 0:
                  tempList = data.policyInformation.list;
                  this.total = data.policyInformation.total;
                  break;
                case 1:
                  tempList = data.serviceItems.list;
                  this.total = data.serviceItems.total;
                  break;
                case 2:
                  tempList = data.pensionAgency.list;
                  this.total = data.pensionAgency.total;
                  break;
                case 3:
                  tempList = data.communityFacility.list;
                  this.total = data.communityFacility.total;
              }

              if (tempList && tempList.length) {
                if (type === "load") {
                  this.list = this.list.concat(tempList);
                } else {
                  this.list = tempList;
                }
              } else {
                this.finished = true;
              }
            }
          })
          .catch(() => {
            if (type === "load") {
              this.loading = false;
            } else if (type === "refresh") {
              this.refreshing = false;
            }
          });
      }
    },

    onLoad() {
      console.log("onLoad");
      let a = this.getData("load");
      console.log(`a${a}`);
      if (!a) {
        this.loading = false;
      }
    },
    onRefresh() {
      console.log("onRefresh");
      // 清空列表数据
      // this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      // this.loading = true;
      this.finished = false;
      let a = this.getData("refresh");
      if (!a) {
        this.refreshing = false;
      }
    },
    togglePage(name, item) {
      this.$router.push({
        name,
        query: { id: item.id, title: item.title, serviceName: item.serviceName }
      });
    },
    toggleOrg(name, orgId) {
      this.$router.push({ name, query: { orgId } });
    },
    handleChange(name) {
      console.log("handleChange");
      this.finished = false;
      this.form.selectType = name + 1;
      this.total = 0;
      this.list = [];
      this.getData("hand");
    }
  },
  mounted() {
    console.log(this.$route.query);
    this.form.idCard = JSON.parse(this.$route.query.data).idCard;
    this.getData = debounce(this.getDataForApi, 300);
    // this.getDataForApi();
  }
};
</script>

<style lang="scss" scoped>
.query_result {
  .van-tabs {
    ::v-deep {
      .van-tab.van-tab--active {
        .van-tab__text {
          opacity: 1;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: center;
          color: #543302;
        }
      }
      .van-tab__text {
        opacity: 0.75;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: center;
        color: #7a7a7a !important;
      }
      .van-tabs__wrap {
        border-bottom: 8px solid rgba(210, 238, 255, 0.5);
        padding-bottom: 10px;
        box-sizing: content-box;

        .van-tabs__line {
          background-color: #7dceff;
          height: 5px;
          width: 30px;
        }
      }
    }
    .title {
      opacity: 1;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: left;
      color: #7a7a7a;
      line-height: 50px;
      padding-left: 20px;
      span {
        padding: 0 5px;
        color: #7dceff;
      }
    }
    .van-cell {
    }
  }
}
</style>
